import { RouteObject } from "react-router-dom";
import RoutesLanding from "./components/routesLanding/routesLanding";
import RouteCreateWithDashboard from "./components/routesAdd/routeAdd";
import RouteView from "./components/routeView/routeView";
import RouteDetails from "./components/details/landing";
import { AddRoute } from "./components/create/create";

export interface mxRouteManagementRoute
  extends Omit<RouteObject, "children"> {
  auth?: boolean;
  children?: mxRouteManagementRoute[];
}
export const mxRouteManagementRoutes: mxRouteManagementRoute[] = [
  {
    path: "/mx/routeManagement/",
    element: <RoutesLanding />,
  },
  {
    path: "/mx/routeManagement/:action/:route_id/:route_name",
    element: <AddRoute />,
  },
  {
    path: "/mx/routeManagement/:action",
    element: <AddRoute />,
  },
  {
    path: "/mx/routeManagement/:action/:route_id",
    element: <AddRoute />,
  },
  {
    path: "/mx/routeManagement/view/view-details/:route_id/:route_name",
    element: <RouteDetails />,
  },
];
